// v2
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
window.__APP_BUILD__ = '20260514b';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
